import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    card: {
        display: 'flex',
        flexDirection: 'column',
    },
    img: {
        width: '100%',
        height : 165,
        [theme.breakpoints.down('xs')]: {
            height: 500,
        },
    },
    content: {
        textAlign: 'center',
        color : theme.palette.primary.main
    }
}))
